type Defaults =
  | 'csid'
  | 'artifactId'
  | 'artifactIdNew'
  | 'componentName'
  | 'componentIdNew'
  | 'componentType'
  | 'resource'
  | 'domain'
  | 'product'
  | 'cairoVersion';

type ReportFn<P, T> = (params: Omit<P, Defaults>) => T;
type ReportFnWithout<P, T, I extends string> = (
  params: Omit<P, Defaults | I>,
) => T;

export function withoutDefaults<P, T>(fn: (params: P) => T): ReportFn<P, T> {
  return fn as ReportFn<P, T>;
}

export const withoutIrrelevant = <I extends string>() =>
  withoutDefaults as <P, T>(fn: (params: P) => T) => ReportFnWithout<P, T, I>;
